import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetOtherSubjectRolesAction} from '../action';

const tableId = 'userOtherSubjectRoles';

function* execute({payload: {request: tableDataRequest, userProfileId}}: GetOtherSubjectRolesAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getUserOtherSubjectPage,
        successAction: adminAction.getOtherSubjectRolesSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}

/** Runs the admin saga that loads other-subject roles for the selected user. */
export function* getUserOtherSubjectRolesSaga(): SagaIterator {
    yield takeLatestF('admin/GET_USER_OTHER_SUBJECT_ROLES', execute);
}
